import { isLoggedInAtom } from 'app/atoms';
import { useAtomValue } from 'jotai';
import { useUser } from 'app/network/user';
import { DynamicFeatureFlag, isFeatureEnabled, isWhiteLabel } from 'app/utils/helpers';

/** Partage Club and Partake share the core deployment, with no WHITE_LABEL. */
export function useSocialLinks() {
  const loggedIn = useAtomValue(isLoggedInAtom);
  const { data: user, isPending } = useUser();
  return {
    isPending,
    enabled:
      loggedIn && !isPending && !isWhiteLabel() && isFeatureEnabled(DynamicFeatureFlag.SocialLinks, user?.featureFlags),
  };
}
